export default __webpack_public_path__ + "static/media/mockPhoto.b135dcd5.png";